import React from 'react'
import SpinnerUI from '../output/SpinnerUI'
import ButtonUI from '../action/ButtonUI'
import ButtonTinyUI from '../action/ButtonTinyUI'
import ButtonLinkUI from '../action/ButtonLinkUI'
import ErrorMessageUI from './ErrorMessageUI'
import SuccessMessageUI from './SuccessMessageUI'
import './Form.css'

const FormUI = ({context, className, inlineButton,
    messageList, buttonLabel, buttonMessageKey, cancelLabel, cancelMessageKey,
    successMsg, errorList, errorCode, errorMessageList,
    busy, disabled, onSubmit, onCancel, children}) =>
  <form className={`w_form ${className ? className : ''}`} onSubmit={onSubmit}>
    <SuccessMessageUI successMsg={successMsg} />
    <ErrorMessageUI errorList={errorList} />
    {
      (errorCode === 'SubscriptionNotActive' || errorCode === 'PlanLimitExceeded') &&
      <div className='g_text_right'>
        <ButtonLinkUI context={context} messageList={errorMessageList}
          labelKey={errorCode === 'SubscriptionNotActive' ? 'c_activate_sub' : 'c_upgrade_plan'}
          to='/settings/account/subscription'
        />
      </div>
    }
    {children}
    {
      (cancelMessageKey || cancelLabel || buttonMessageKey || buttonLabel) &&
      <div className={`${inlineButton ? '' : 'action'} g_flex_h`}>
        {
          (cancelMessageKey || cancelLabel) &&
          <ButtonUI
            label={cancelLabel}
            messageList={messageList}
            labelKey={cancelMessageKey}
            transparent={true}
            onClick={onCancel}
            type={"button"}
          />
        }
        <SpinnerUI show={busy} />
        {
          (buttonMessageKey || buttonLabel) && !inlineButton &&
          <ButtonUI
            label={buttonLabel}
            messageList={messageList}
            labelKey={buttonMessageKey}
            onClick={onSubmit}
            disabled={busy || disabled}
          />
        }
        {
          (buttonMessageKey || buttonLabel) && inlineButton &&
          <ButtonTinyUI
            label={buttonLabel}
            messageList={messageList}
            labelKey={buttonMessageKey}
            onClick={onSubmit}
            disabled={busy || disabled}
          />
        }
      </div>
    }
  </form>

export default FormUI
